import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

export function initStoriesSlider() {
    const sliderElements = document.querySelectorAll('.stories-slider');
    
    sliderElements.forEach((sliderElement) => {
        const prevButton = sliderElement.closest('section').querySelector('.stories-prev');
        const nextButton = sliderElement.closest('section').querySelector('.stories-next');
        const paginationEl = sliderElement.closest('section').querySelector('.stories-pagination');
        
        new Swiper(sliderElement, {
            modules: [Navigation, Pagination, EffectFade],
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            slidesPerView: 1,
            spaceBetween: 16,
            speed:800,
            loop: false,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
                bulletClass: 'stories-bullet',
                bulletActiveClass: 'stories-bullet-active',
                renderBullet: function (index, className) {
                    return `<button type="button" class="${className}" aria-label="Go to slide ${index + 1}"></button>`;
                },
            },
            
        });
    });
}
